import '@dreamstack/datadog/init' // Initialize datadog with side-effects
import { ExitPreview } from '@dreamstack/feature-components/src/layout/ExitPreview'
import { createEmotionCache } from '@dreamstack/theme'
import { trpc } from '@dreamstack/trpc/client'
import type { EmotionCache } from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import 'keen-slider/keen-slider.min.css'
import { appWithTranslation } from 'next-i18next'
import type { AppProps } from 'next/app'
import type { AppContextType } from 'next/dist/shared/lib/utils'
import { RefreshRouteOnSave } from '../lib/payload/RefreshRouteOnSave'
import { MainProvider } from '../lib/provider/MainProvider'
import '../public/fonts/fontfaces.css'
import '../tailwind.css'

const clientSideEmotionCache = createEmotionCache()

interface MyAppProps extends AppProps {
  emotionCache?: EmotionCache
}

function MyApp({
  Component,
  pageProps,
  emotionCache = clientSideEmotionCache,
}: MyAppProps) {
  return (
    <CacheProvider value={emotionCache}>
      <MainProvider pageProps={pageProps}>
        <RefreshRouteOnSave />
        <ExitPreview />
        <Component {...pageProps} />
        <SpeedInsights />
      </MainProvider>
    </CacheProvider>
  )
}

MyApp.getInitialProps = async (appContext: AppContextType) => {
  const context = appContext.ctx as any
  if (appContext.router.isPreview) {
    context.HACKY_IS_PREVIEW = true
  }
  return {}
}

export default trpc.withTRPC(appWithTranslation(MyApp))
